"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Buttons = require("../../Buttons");
var _react = _interopRequireWildcard(require("react"));
var _edSystem = require("@eduact/ed-system");
var _Attachment = require("../../DataDisplay/Attachment");
var _Feedback = require("../../Feedback");
var _Cards = require("../../Cards");
var _Icons = require("../../Icons");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var AttachmentAnswer = function AttachmentAnswer(_ref) {
  var onFileChange = _ref.onFileChange,
    value = _ref.value,
    accept = _ref.accept,
    onDelete = _ref.onDelete;
  var inputRef = (0, _react.useRef)(null);
  var triggerInput = function triggerInput() {
    var _inputRef$current;
    return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
  };
  var filesChange = function filesChange(ev) {
    onFileChange === null || onFileChange === void 0 ? void 0 : onFileChange(ev.target.files);
  };
  var attachments = (0, _react.useMemo)(function () {
    if (!value || !Array.isArray(value)) return [];
    return value.map(function (_) {
      return {
        type: _.split('.').pop(),
        url: _
      };
    });
  }, [value]);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    deleteModalOpen = _useState4[0],
    setDeleteModalOpen = _useState4[1];
  var _useState5 = (0, _react.useState)(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    toBeDeleted = _useState6[0],
    setToBeDeleted = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedPreview = _useState8[0],
    setSelectedPreview = _useState8[1];
  var onDeleteAttachment = function onDeleteAttachment() {
    if (!value || toBeDeleted === -1) return;
    var _attachments = value;
    _attachments.splice(toBeDeleted, 1);
    setDeleteModalOpen(false);
    onDelete === null || onDelete === void 0 ? void 0 : onDelete(_attachments);
  };
  var handleDeleteModal = function handleDeleteModal(index) {
    setToBeDeleted(index);
    setDeleteModalOpen(true);
  };
  var handleCloseDeleteModal = function handleCloseDeleteModal() {
    setToBeDeleted(-1);
    setDeleteModalOpen(false);
  };
  return /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    gridGap: '2.875rem',
    alignItems: 'center'
  }, /*#__PURE__*/_react["default"].createElement(_Feedback.Modal, {
    withStyling: true,
    center: true,
    onClose: function onClose() {
      setSelectedPreview(null);
      setModalOpen(false);
    },
    open: modalOpen
  }, /*#__PURE__*/_react["default"].createElement(_Cards.Card, {
    p: '1rem',
    variant: 'light',
    maxHeight: '90vh',
    maxWidth: '90vw',
    overflow: 'auto'
  }, /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'auto'
  }, selectedPreview && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _Attachment.imageTypes.includes(selectedPreview.type) && /*#__PURE__*/_react["default"].createElement("object", {
    type: "image",
    data: selectedPreview === null || selectedPreview === void 0 ? void 0 : selectedPreview.url
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: selectedPreview.url
  })), selectedPreview.type === 'pdf' && /*#__PURE__*/_react["default"].createElement("object", {
    style: {
      width: '90vw',
      height: '90vh'
    },
    data: selectedPreview.url,
    datatype: "application/pdf"
  }, /*#__PURE__*/_react["default"].createElement("iframe", {
    width: '100%',
    height: '100%',
    src: selectedPreview.url,
    title: "Pdf"
  })))))), /*#__PURE__*/_react["default"].createElement(_Feedback.Dialog, {
    maxWidth: '90vw',
    width: 'fit-content',
    height: 'fit-content',
    open: deleteModalOpen,
    onClose: handleCloseDeleteModal
  }, /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    gridGap: '2rem',
    p: '2rem',
    flexDirection: "column"
  }, /*#__PURE__*/_react["default"].createElement(_edSystem.Typography, null, "Are you sure to delete attachment"), /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    gridGap: {
      sm: '0.5rem',
      lg: '2rem'
    },
    flexWrap: 'wrap',
    justifyContent: 'flex-end'
  }, /*#__PURE__*/_react["default"].createElement(_Buttons.RaisedButton, {
    onClick: onDeleteAttachment,
    btnSize: 'small',
    variant: "princetonOrange"
  }, "Delete"), /*#__PURE__*/_react["default"].createElement(_Buttons.RaisedButton, {
    onClick: handleCloseDeleteModal,
    btnSize: 'small',
    outlined: true
  }, "Cancel")))), /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    gridGap: '1.5rem',
    width: '100%',
    flexWrap: 'wrap',
    alignItems: 'center'
  }, attachments.map(function (attachment, index) {
    return /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
      justifyContent: {
        sm: 'space-between',
        lg: 'initial'
      },
      alignItems: {
        sm: 'center'
      },
      width: {
        sm: '100%',
        lg: 'fit-content'
      },
      key: "".concat(attachment.url, "-").concat(attachment.type, "-").concat(index)
    }, /*#__PURE__*/_react["default"].createElement(_Attachment.Attachment, {
      onClick: function onClick(attachment) {
        if (!_Attachment.imageTypes.includes(attachment.type) && attachment.type !== 'pdf') {
          window.open(attachment.url, '_blank');
          return;
        }
        setSelectedPreview(attachment);
        setModalOpen(true);
      },
      onDelete: function onDelete(attachment) {
        return handleDeleteModal(index);
      },
      url: attachment.url,
      type: attachment.type
    }), /*#__PURE__*/_react["default"].createElement(_edSystem.Box, {
      display: {
        sm: 'block',
        lg: 'none'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icons.Icon, {
      onClick: function onClick() {
        return handleDeleteModal(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icons.Icons.Trash, null))));
  }), /*#__PURE__*/_react["default"].createElement(_Buttons.RaisedButton, {
    onClick: triggerInput,
    btnSize: 'small',
    p: {
      sm: '6px 10px',
      lg: '6px 10px'
    },
    outlined: true,
    borderRadius: 4,
    withRipple: true,
    width: 'fit-content',
    minWidth: 'unset',
    variant: "princetonOrange"
  }, "Add"), /*#__PURE__*/_react["default"].createElement(_edSystem.Typography, null, "Max size: 5MB")), /*#__PURE__*/_react["default"].createElement("input", {
    onChange: filesChange,
    onClick: function onClick(e) {
      e.currentTarget.value = '';
    },
    ref: inputRef,
    type: 'file',
    accept: accept,
    multiple: true,
    hidden: true
  }));
};
var _default = AttachmentAnswer;
exports["default"] = _default;